import * as Actions from "../../actions/ecommerce/constants";

const initialState = {
  dialogs: {
    success: {
      cobroPaymentRequest: {
        title: "",
        message: "",
        shown: false,
      },
    },
    error: {
      // TODO: error scenario come back
      cobroPaymentRequest: {},
    },
  },
};
function Ecommerce(state = initialState, action) {
  switch (action.type) {
    case Actions.CLEAR_SUCCESS: {
      return {
        ...state,
        dialogs: {
          ...state.dialogs,
          success: {
            ...state.dialogs.success,
            cobroPaymentRequest: {
              title: "",
              message: "",
              shown: false,
            },
          },
        },
      };
    }
    case Actions.SET_SUCCESS_COBRO_EXPRESS: {
      return {
        ...state,
        dialogs: {
          ...state.dialogs,
          success: {
            ...state.dialogs.success,
            cobroPaymentRequest: {
              title: action.payload.title,
              message: action.payload.message,
              shown: true,
            },
          },
        },
      };
    }
    default: {
      return state;
    }
  }
}
export default Ecommerce;
